import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { options, references } from '@apexdesigner/schema-tools';

export const sessionHistory = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    date: z.string().nullable().optional().presentAs('date').describe('Date'),

    attendanceType: options([
      { value: 'Present', name: 'Present' },
      { value: 'Absent', name: 'Absent' },
    ])
      .nullable()
      .optional()
      .describe('Attendance Type'),

    studentId: z
      .number()
      .presentAs('reference')
      .describe('Foreign key to Student'),

    student: references('Student'),
  })
  .describe(
    "A read-only view joining sessions to attendance, for reporting a student's session timeline.",
  )
  .as('SessionHistory');

export { sessionHistory as sessionHistorySchema };
